import {InfoCircleSolidIcon, RefreshIcon} from "@hosttools/frontend";
import {
    Badge,
    BadgeIcon,
    BadgeText,
    Button,
    ButtonIcon,
    ButtonText,
    HStack,
    Text
} from "@hosttools/frontend/components";
import type {AccountChannel} from "@hosttools/frontend/models/account";
import type React from "react";
import {memo, useCallback} from "react";

type Props = {
    account: AccountChannel;
    onReconnect: (account: AccountChannel) => void;
};

const BadAccountItem: React.FC<Props> = ({account, onReconnect}) => {
    const handleReconnect = useCallback(() => {
        onReconnect(account);
    }, [account, onReconnect]);

    return (
        <HStack className="items-center" space="md">
            <Text color="blueGray.800" variant="md">
                {account.username}
            </Text>
            <Badge action="error">
                <BadgeIcon as={InfoCircleSolidIcon} />
                <BadgeText>Account Disconnected</BadgeText>
            </Badge>
            <Button variant="ghost" onPress={handleReconnect}>
                <ButtonIcon as={RefreshIcon} />
                <ButtonText>Reconnect</ButtonText>
            </Button>
        </HStack>
    );
};

export default memo(BadAccountItem);
